import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import type { Container } from '../../di/container';
import { ContainerProvider } from '../../di/ContainerProvider';
import { Toaster } from '../components/Toaster';
import { createRouter } from './router';
import { SessionBootstrap } from './guards';
import { PrefsSync } from './PrefsSync';
import { ThemeController } from './ThemeController';

export function App({ container }: { container: Container }) {
  const [router] = useState(createRouter);
  return (
    <ContainerProvider container={container}>
      <ThemeController />
      <PrefsSync />
      <SessionBootstrap>
        <RouterProvider router={router} />
      </SessionBootstrap>
      <Toaster />
    </ContainerProvider>
  );
}
